import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaSignOutAlt, FaUser } from 'react-icons/fa';
import { useUser } from '@/contexts/UserContext';
import { useAuthContext } from '@/contexts/AuthContext';
import { useDeploymentUrls } from '@/contexts/DeploymentUrlsContext';

const UserIcon = ({ className }: { className?: string }) => (
  <div
    className={`p-1.5 bg-gray-200 rounded-full flex items-center justify-center text-gray-600 transition-all duration-200 ${className}`}
  >
    <FaUser className=" text-sm" />
  </div>
);

const PersonButton: React.FC = () => {
  const { userData } = useUser();
  const [showLogout, setShowLogout] = useState(false);
  const { t } = useTranslation();
  const { logout } = useAuthContext();
  const { deploymentUrls } = useDeploymentUrls();

  const handleMouseEnter = () => {
    setShowLogout(true);
  };

  return (
    <div
      className="relative top-0"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setShowLogout(false)}
    >
      <div className="flex rounded-full items-center bg-transparent text-gray-700 cursor-pointer transition-all duration-200 px-2 py-1  mr-3">
        <UserIcon className="hover:text-gray-100 hover:bg-gray-900" />
        {userData?.first_name ? (
          <span className="ml-2 text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-50">
            {userData.first_name}
          </span>
        ) : null}
      </div>
      {showLogout && (
        <div className="absolute top-full right-0 pt-1 w-64 person-button-container">
          <div className="bg-white rounded-lg text-sm overflow-hidden shadow-lg border border-gray-200">
            <div className="flex px-4 py-3 text-gray-700 w-full">
              {userData?.full_name ? (
                <div className="flex items-center w-full gap-3">
                  <UserIcon />
                  <div className="flex flex-col">
                    <span className="text-sm font-medium text-gray-900">
                      {userData.full_name}
                    </span>
                    <span className="text-xs text-gray-500">
                      {userData.email}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="flex items-center w-full gap-3">
                  <UserIcon />
                  <span className="text-sm text-gray-500">
                    {userData?.email}
                  </span>
                </div>
              )}
            </div>

            <div className="border-t border-gray-100">
              {deploymentUrls?.apiUrl && (
                <a
                  className="flex px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 w-full transition-colors duration-150"
                  href={`${
                    deploymentUrls?.apiUrl
                  }/system/sdx/users/recover/send/`}
                >
                  {t("navbar.change_password")}
                </a>
              )}
              <button
                className="flex px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 w-full transition-colors duration-150 border-t border-gray-100"
                onClick={logout}
              >
                <div className="flex gap-2 items-center">
                  <FaSignOutAlt className="text-gray-500 text-sm" />
                  <span>{t("navbar.logout")}</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const HorizontalNavbar: React.FC = () => {
  return (
    <nav
      className={`bg-white flex pl-12 justify-end items-center border-b-[2px] border-gray-300 text-black z-20 h-12`}
      style={{ minHeight: '3rem', height: '100%' }}
    >
      <div className='flex items-center h-full'>
        <PersonButton/>
      </div>
    </nav>
  );
};

export default HorizontalNavbar;
